app.factory(
    'BioService', ['LocalStorage', 'ApiService', '$rootScope', BioService]
);

function BioService(LocalStorage, ApiService, $rootScope) {

    self.GetAll = GetAll;
    self.GetBio = GetBio;
    self.GetBioForCreation = GetBioForCreation;
    self.CreateNewBio = CreateNewBio;
    self.UpdateBio = UpdateBio;
    self.UpdateDescription = UpdateDescription;
    self.GetBioList = GetBioList;
    

    function GetAll() {
        return ApiService.get('/api/bioAPI/GetBioTrans').then(handleSuccess, handleError('Error getting all Bios'));
    }

    ////Get  Bio List
    //function GetBioList(itemsPerPage, pagenumber, sortKey, reverse, lang, AdvancedSearch) {
    //    return ApiService.get("/api/bioAPI/GetBioList?itemsPerPage=" + itemsPerPage + "&pagenumber=" + pagenumber + "&sortKey=" + sortKey + "&reverse=" + reverse + "&lang=" + lang);
    //}

    //Get  Bio List
    function GetBioList(zoneId, qc, itemsPerPage, pagenumber, sortKey, reverse, lang, isTopBarActive, sparams, sgparams, searchText, AdvancedSearch) {
        var request = ApiService.post("/api/bioAPI/GetBioList?zoneId=" + zoneId + "&qc=" + qc + "&itemsPerPage=" + itemsPerPage + "&pagenumber=" + pagenumber + "&sortKey=" + sortKey + "&reverse=" + reverse + "&lang=" + lang + "&itba=" + isTopBarActive + "&sparams=" + sparams + "&sgparams=" + sgparams + "&st=" + encodeURIComponent(searchText), AdvancedSearch);
        return request;
    }

    function GetBio(id, lang, lang2, index, sortKey, reverse) {
        return ApiService.get('/api/bioAPI/GetBioTrans?id=' + id + "&lang=" + lang + "&lang2=" + lang2 + "&index=" + index + "&sortKey=" + sortKey + "&reverse=" + reverse).then(handleSuccess, handleError('Error getting Bio by id'));
    }

    self.GetBioPreview = function (id, lang) {
        return ApiService.get('/api/bioAPI/GetBioPreview?id=' + id + "&lang=" + lang);
    }

    //Update  
    function UpdateBio(Bio) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(Bio);
        var request = ApiService.post("/api/BioApi/UpdateBio?id=" + Bio.BioId, st).then(function (data) {
        })
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Create
    function CreateNewBio(BioVm) {
        var st = JSON.stringify(BioVm);
        var request = ApiService.post("/api/BioApi/CreateNewBio", st);        
        return request;
    }

    //GetBioForCreation
    function GetBioForCreation(qc, lang) {
        var request = ApiService.get("/api/BioApi/GetBioForCreation?qc=" + qc + "&lang=" + lang).then(handleSuccess, handleError('Error Create new bio'));        
        return request;
    }
    
   
    //Create New Description and associate with Bio
    self.CreateNewDescriptionForBio = function (descForCreation) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(descForCreation);
        var request = ApiService.post("/api/DescriptionApi/CreateNewDescriptionForObject/", st)
            .then(
                function success(data) {
                    $rootScope.returnNewDesc = angular.copy(data.data);
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }


    //self.GetSearchUrlParam = function (zoneId, itemsPerPage, pagenumber, sortKey, reverse, lang, isTopBarActive, searchText, AdvancedSearch) {
    //    var request = ApiService.post("/api/BioApi/GetSearchUrlParam?zoneId=" + zoneId + "&itemsPerPage=" + itemsPerPage + "&pagenumber=" + pagenumber + "&sortKey=" + sortKey + "&reverse=" + reverse + "&lang=" + lang + "&itba=" + isTopBarActive + "&st=" + encodeURIComponent(searchText), AdvancedSearch);
    //    return request;
    //}


    // private functions

    function handleSuccess(res) {
        return res.data;
    }

    function handleError(error) {
        return function () {
            return { success: false, message: error };
        };
    }




    return self;
}